$(document).ready(function () {
	$('.employee-modal-link').fancybox({
		type: 'iframe',
		iframe: { css: { width: '600px' } },
		smallBtn: true,
		buttons: [],
		afterShow: function (opts, obj) {
			$('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe')
		},
	})
})

function toggleIwLoginDrop(event) {
	event.stopPropagation()
	var isOpen = $('.iw-login__drop').toggleClass('show').hasClass('show')
	$('.iw-login__drop').attr('aria-hidden', !isOpen)
	$('#iwLoginBtn').attr('aria-expanded', isOpen)
	$('#iwMobLoginBackdrop').toggleClass('open')
}

$(document).on('click', function () {
	$('.iw-login__drop').removeClass('show').attr('aria-hidden', true)
	$('#iwLoginBtn').attr('aria-expanded', false)
	$('#iwMobLoginBackdrop').removeClass('open')
})

function iwOpenMobMenu() {
	$('#iwMobMenu').toggleClass('open')
}

function iwCloseMobMenu() {
	$('#iwMobMenu').removeClass('open')
}

function iwConfirmLogout() {
	$('#iwUbModal').addClass('open')
}

function iwCloseLogoutModal() {
	$('#iwUbModal').removeClass('open')
}

function iwDoLogout() {
	$('#iwUbModal').removeClass('open')
	$('.iw-login__guest').prop('hidden', false)
	$('#iwLoginUser').prop('hidden', true)
	$('.header-logo__slogan').removeClass('hide')
	$('.iw-header__ikona').removeClass('show')
	$('#iwToastContainer2').addClass('show')
	setTimeout(function () {
		$('#iwToastContainer2').removeClass('show')
	}, 3000)
}

function iwDoLogin() {
	$('.iw-login__guest').prop('hidden', true)
	$('#iwLoginUser').prop('hidden', false)
	$('.header-logo__slogan').addClass('hide')
	$('.iw-header__ikona').addClass('show')
	$('#iwToastContainer').addClass('show')
	setTimeout(function () {
		$('#iwToastContainer').removeClass('show')
	}, 3000)
}

function iwDoLoginFirma() {
	$('#iwToastContainer3').addClass('show')
	setTimeout(function () {
		$('#iwToastContainer3').removeClass('show')
	}, 3000)
}

var iwEmailPhase = 'idle'

function iwEmailStart(event) {
	event.stopPropagation()
	iwEmailPhase = 'email'
	$('#iwEmailInput').val('').attr('placeholder', 'Zadejte svůj e-mail').attr('type', 'email')
	$('#iwEmailStep .fp-login__odeslat').text('Odeslat kód')
	$('#iwEmailStep').prop('hidden', false)
	$('#iwEmailInput').focus()
}

function iwEmailSubmit(event) {
	event.preventDefault()
	if (iwEmailPhase === 'email') {
		var email = $('#iwEmailInput').val()
		$('#iwToastEmail').text(email)
		$('#iwToastContainer4').addClass('show')
		setTimeout(function () {
			$('#iwToastContainer4').removeClass('show')
		}, 3000)
		$('#iwEmailInput').val('').attr('placeholder', 'Zadejte kód z e-mailu').attr('type', 'text')
		$('#iwEmailStep .fp-login__odeslat').text('Přihlásit')
		iwEmailPhase = 'code'
	} else if (iwEmailPhase === 'code') {
		iwEmailPhase = 'idle'
		$('#iwEmailStep').prop('hidden', true)
		$('.iw-login__drop').removeClass('show').attr('aria-hidden', true)
		$('#iwLoginBtn').attr('aria-expanded', false)
		$('#iwMobLoginBackdrop').removeClass('open')
		iwDoLogin()
	}
}
